import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import {
  SummaryReport,
  SummaryReportReviewPATCH,
} from 'schemas/SummaryReport.schema';
import { apiFetch } from 'utils/apiUtils';

export interface ReviewSummaryReportVariables {
  teamId: string;
  campaignId: string;
  iterationId: string;
  batchId: string;
  summaryReportPatch: SummaryReportReviewPATCH
}

export default function usePatchReportReview() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['summary_report', 'campaign'],
    mutationFn: async ({
      teamId,
      campaignId,
      iterationId,
      batchId,
      summaryReportPatch,
    }: ReviewSummaryReportVariables) => apiFetch<SummaryReport>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary_report/${batchId}/review`,
      method: 'PATCH',
      accessToken: String(tokens.accessToken),
      body: summaryReportPatch,
    }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['campaign'] });
      queryClient.refetchQueries({ queryKey: ['summary_report'] });
    },
  });
}
